// extracted by mini-css-extract-plugin
export var bleed = "blog-carou-module--bleed--15220";
export var carou = "blog-carou-module--carou--921d5";
export var carousel = "blog-carou-module--carousel--3ffb1";
export var factory = "blog-carou-module--factory--db519";
export var nd_homeCaption = "blog-carou-module--nd_home-caption--8b187";
export var noscroll = "blog-carou-module--noscroll--ee0d4";
export var scroll = "blog-carou-module--scroll--472b7";
export var story_fixed = "blog-carou-module--story_fixed--ff444";
export var story_fullCaption = "blog-carou-module--story_full-caption--0658f";
export var story_sec = "blog-carou-module--story_sec--53b04";